import * as React from "react";
const SvgFiRrTrafficCone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-traffic-cone_svg__a)">
      <path
        fill="#062147"
        d="M23 22h-.873L14.773 1.979A2.93 2.93 0 0 0 12 .045c-1.252 0-2.341.76-2.773 1.936L1.873 22H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2M7.676 12h8.647l1.469 4H6.207zm3.427-9.33a.93.93 0 0 1 .896-.625c.156 0 .683.045.896.625L15.588 10H8.41zM5.472 18h13.056l1.469 4H4.003z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-traffic-cone_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrafficCone;
